<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/102oNB2/images/cover.jpg?1684979201320" alt="This image is the cover for the book A Life That Is Good"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">A Life That Is Good
      </h1>
      <p class="bookDescription body article font2">
        <p>Somewhere out there is the “good life,” and we’re all scrambling to get it. Glenn Pemberton maintains in this book that we find the so-called good life not in good things but in living well—and the biblical book of Proverbs teaches us how to live that life.</p><p>Though based on solid biblical scholarship, <i>A Life That Is Good</i> is not a textbook, commentary, or comprehensive study. It is instead a readable, practical guide to the wisdom found in the ancient book of Proverbs—wisdom on everyday living, speech, relationships, justice, money, and much more. Pastors and church groups in particular will love and benefit from this relevant guide regarding the message of Proverbs for today’s world.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Glenn Pemberton, Tremper Longman
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      William B. Eerdmans Publishing Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?54e6daee